/* eslint-disable max-classes-per-file */
class BreakpointNotFoundError extends Error {
  constructor(breakpoint) {
    super("Breakpoint '".concat(breakpoint, "' not found"));
  }

}

class NextBreakpointNotFoundError extends Error {
  constructor(breakpoint) {
    super("Next breakpoint for '".concat(breakpoint, "' not found"));
  }

}

export { BreakpointNotFoundError, NextBreakpointNotFoundError };
//# sourceMappingURL=errors.js.map